<template>
  <section class="nodes-section">
    <div class="nodes-overlay"></div>
    <div class="section-header">
      <!-- <span class="section-badge">🌍 全球部署</span> -->
      <h2 class="section-title">
        {{ $t("tokenList.title1") }}<span class="highlight"
          >{{ $t("tokenList.title2") }}</span
        >
      </h2>
      <p class="section-desc">{{ $t("tokenList.desc") }}</p>
    </div>
    <div class="nodes-grid">
      <div class="node-card" v-for="node in nodes" :key="node.id">
        <!-- 标签：与 ServerList 一致 -->
        <div class="node-card-badges">
          <span
            :class="['badge', getTagClass(node.tag)]"
            >{{ getTagTitle(node.tag) }}</span
          >
        </div>
        <h3 class="node-name">{{ node.title }}</h3>
        <div class="node-flag">
          <img class="flag-img" :src="node.country_img" alt="Flag" />
        </div>
        <div class="node-specs">
          <span class="price-value"
            >${{ node?.top_data?.latest_price }} <em>/ 1000 TFLOPS</em></span
          >
        </div>
        <!-- <div class="node-tag" :class="node.tagClass">{{ node.tag }}</div> -->

        <div>
          <PowerGrowthChart :data="node?.top_trend" />
        </div>

        <!-- ===== 4个字段：左右布局 ===== -->
        <!-- <div class="node-stats-list">
          <div class="node-stat-row">
            <span class="node-stat-label">最新</span>
            <span class="node-stat-value"
              >${{ node?.top_data?.latest_price }}</span
            >
          </div>
          <div class="node-stat-row">
            <span class="node-stat-label">昨日</span>
            <span class="node-stat-value">{{
              node?.top_data?.last_price
            }}</span>
          </div>
          <div class="node-stat-row">
            <span class="node-stat-label">增幅</span>
            <span
              class="node-stat-value"
              :class="getIncreaseClass(node?.top_data?.rate)"
            >
              {{ node?.top_data?.rate }}
            </span>
          </div>
        </div> -->

        <!-- ✅ 两个按钮：详情 + 立即购买 -->
        <div class="node-actions">
          <!-- <button class="btn btn-detail" @click="handleDetail(node)">
            详情
          </button> -->
          <button class="btn btn-buy" @click="handleBuy(node)">
            {{ $t("tokenList.buy") }}
          </button>
        </div>
      </div>
    </div>

    <!-- ✅ 更多产品按钮 -->
    <div class="more-products">
      <button class="btn-more" @click="handleMoreProducts">
        {{ $t("tokenList.more") }}
        <span class="more-arrow">→</span>
      </button>
    </div>
  </section>
</template>

<script>
const TAG_MAP = {
  1: {
    titleKey: "tokenList.tagHot",
    class: "badge-hot",
  },
  2: {
    titleKey: "tokenList.tagProfit",
    class: "badge-profit",
  },
};
import PowerGrowthChart from "@/components/chart/PowerGrowthChart.vue";
export default {
  components: {
    PowerGrowthChart,
  },
  data() {
    return {
      // ===== 节点数据 =====
      nodes: [],
    };
  },
  created() {
    this.getTokenTop();
  },
  methods: {
    getTagClass(tag) {
      return TAG_MAP[tag]?.class || "";
    },
    getTagTitle(tag) {
      const key = TAG_MAP[tag]?.titleKey;
      return key ? this.$t(key) : "";
    },
    async getTokenTop() {
      const res = await this.$api.token.getTokenTop();
      if (res.code === 1) {
        this.$message.warning(res.msg);
        return;
      }
      this.nodes = res.data;
    },
    getIncreaseClass(value) {
      if (!value) return "";
      const num = parseFloat(value);
      if (isNaN(num)) return "";
      return num >= 0 ? "increase-up" : "increase-down";
    },
    // ✅ 详情按钮
    handleDetail(node) {
      console.log("查看详情:", node);
      this.$router.push({
        path: "/info",
        query: {
          code: node.code,
        },
      });
    },
    // ✅ 立即购买按钮
    handleBuy(node) {
      console.log("购买:", node);
      this.$router.push({
        path: "/info",
        query: {
          code: node.code,
        },
      });
    },
    // ✅ 更多产品按钮
    handleMoreProducts() {
      console.log("更多产品");
      this.$router.push({
        path: "/info",
      });
    },
  },
};
</script>

<style>
/* ============================================================
   全局重置 & 通用
   ============================================================ */
.home-page {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  background: #0a0e1a;
  color: #fff;
  overflow-x: hidden;
}

.section-header {
  text-align: center;
  margin-bottom: 48px;
}

.section-badge {
  display: inline-block;
  padding: 4px 16px;
  border-radius: 20px;
  background: rgba(0, 180, 255, 0.08);
  border: 1px solid rgba(0, 180, 255, 0.1);
  font-size: 13px;
  color: #00b4ff;
  margin-bottom: 12px;
}

.section-title {
  font-size: 40px;
  font-weight: 800;
  margin: 0 0 8px 0;
}

.section-desc {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
}

.highlight {
  background: linear-gradient(135deg, #00b4ff, #7c3aed);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* ============================================================
   全球节点
   ============================================================ */
.nodes-section {
  padding: 80px 20px;
  position: relative;
  background: url("../../assets/imgs/bg02.png");
  background-size: 122%;
  background-position: center;
  background-repeat: no-repeat;
  /* margin: 80px 20px; */
}

.nodes-overlay {
  position: absolute;
  inset: 0;
  background: rgba(10, 14, 26, 0.75);
  z-index: 0;
}

.nodes-section .section-header,
.nodes-section .nodes-grid,
.nodes-section .more-products {
  position: relative;
  z-index: 1;
}

.nodes-grid {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.node-card {
  background: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 20px 18px 18px;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  min-width: 0;
}

/* ===== 标签：与 ServerList 一致 ===== */
.node-card-badges {
  display: flex;
  gap: 6px;
  margin-bottom: 10px;
  flex-wrap: wrap;
  height: 21px;
}

.badge {
  padding: 2px 10px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

/* 热门 - 橙色半透明 */
.badge-hot {
  background: rgba(255, 152, 0, 0.15);
  color: #ff9800;
}

/* 高收益 - 绿色半透明 */
.badge-profit {
  background: rgba(0, 201, 81, 0.12);
  color: #00c951;
}

.node-card:hover {
  transform: translateY(-8px);
  border-color: rgba(0, 180, 255, 0.3);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  background: rgba(255, 255, 255, 0.08);
}

.node-flag {
  font-size: 40px;
  margin-bottom: 8px;
}
.node-flag .flag-img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
}

.node-name {
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 4px 0;
}

.node-specs {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 0;
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
}

.price-value {
  font-size: 24px;
  font-weight: 800;
  background: linear-gradient(135deg, #00e5ff, #7c3aed);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-family: "SF Mono", "Courier New", monospace;
  white-space: nowrap;
  filter: drop-shadow(0 0 12px rgba(0, 229, 255, 0.35));
}

.price-value em {
  font-style: normal;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.6);
  -webkit-text-fill-color: rgba(255, 255, 255, 0.6);
}

.node-tag {
  display: inline-block;
  padding: 2px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  margin: 12px 0;
}

.tag-hot {
  background: rgba(255, 152, 0, 0.15);
  color: #ff9800;
}
.tag-recommend {
  background: rgba(0, 180, 255, 0.15);
  color: #00b4ff;
}
.tag-stable {
  background: rgba(0, 201, 81, 0.15);
  color: #00c951;
}
.tag-low {
  background: rgba(124, 58, 237, 0.15);
  color: #7c3aed;
}

.node-stats-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: rgba(255, 255, 255, 0.04);
  border-radius: 10px;
  padding: 10px 14px;
  margin: 8px 0 12px 0;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.node-stat-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 0;
}

.node-stat-label {
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.35);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.node-stat-value {
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
  font-family: "SF Mono", "Courier New", monospace;
}
.increase-up {
  color: #00c951;
}
.increase-down {
  color: #ff6b6b;
}

.btn-node {
  padding: 8px 24px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.btn-node:hover {
  background: rgba(0, 180, 255, 0.15);
  border-color: #00b4ff;
}

/* ===== 按钮组 ===== */
.node-actions {
  display: flex;
  gap: 10px;
  margin-top: 20px;
  justify-content: center;
}

.btn {
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
  border: none;
}

/* 详情按钮 */
.btn-detail {
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.btn-detail:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.2);
}

/* 立即购买按钮 */
.btn-buy {
  background: linear-gradient(135deg, #00b4ff, #7c3aed);
  color: #fff;
  border: none;
}

.btn-buy:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0, 180, 255, 0.3);
}

/* ===== 更多产品按钮 ===== */
.more-products {
  display: flex;
  justify-content: center;
  margin-top: 48px;
}

.btn-more {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 36px;
  border-radius: 30px;
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
  border: 1px solid rgba(0, 180, 255, 0.3);
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.btn-more:hover {
  background: linear-gradient(135deg, #00b4ff, #7c3aed);
  border-color: transparent;
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0, 180, 255, 0.3);
}

.more-arrow {
  font-size: 16px;
  transition: transform 0.3s ease;
}

.btn-more:hover .more-arrow {
  transform: translateX(4px);
}
</style>
